/**
 * Converts IMG tags with SVG images to inline SVG. This way the SVG is cached by the browser and we can manipulate it by CSS
 *
 * @return {void}
 */
pyzel.convertToSVG = function() {

	$('img[src$=".svg"]').each(function() {
		var img = $(this);
		var imgURL = img.attr('src');
		var attributes = img.prop("attributes");

		$.get(imgURL, function(data) {
			// Get the SVG tag, ignore the rest
			var svg = jQuery(data).find('svg');

			// Remove any invalid XML tags
			svg = svg.removeAttr('xmlns:a');

			// Loop through IMG attributes and apply on SVG
			$.each(attributes, function() {
				svg.attr(this.name, this.value);
			});

			// Replace IMG with SVG
			img.replaceWith(svg);
		}, 'xml');
	});

};